module.exports = __webpack_public_path__ + "static/media/consumer-power-mobile.90c95b15.jpg";